// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
}

/* ------------------------------fonts------------------------------ */

.regularFont {
    font-family: "Rajdhani", sans-serif;
    font-weight: 600;
    font-size: 11px;
    letter-spacing: 1px;
    color: #666666;
    padding-left: 14px;
}
  
.scriptFont {
    font-family: "IM Fell English", serif;
    font-size: 16px;
    color: #666666;
    /* letter-spacing: 1px; */
    font-style: italic;
}

.italicScript {
    font-family: "IM Fell English", serif;
    font-size: 15px;
    color: #cccccc;
    letter-spacing: 0px;
    line-height: 20px;
    font-style: italic;
    margin-top: 0px;
  }
  
.serifFont{
    font-family: "Radley", serif;
    font-size: 13px;
    color: #cccccc;
    letter-spacing: 0px;
    margin-top: 8px;
    margin-bottom: 16px;
}

.pageLink {
    font-family: "Rajdhani", sans-serif;
    font-size: 20px;
    letter-spacing: 1px;
    color: #cccccc;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-right: 5px;
    margin-left: 5px;
}

.pressLink {
    font-family: "Rajdhani", sans-serif;
    font-size: 14px;
    letter-spacing: 1px;
    color: #cccccc;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-right: 2px;
    margin-left: 2px;
}

.pressLink a,
.pressLink a:link,
.pressLink a:visited,
.pressLink a:hover,
.pressLink a:active {
  color: #cccccc;
  text-decoration: underline;
}

#contactLink,
#contactLink:link,
#contactLink:visited,
#contactLink:hover,
#contactLink:active {
  color: #cccccc;
  text-decoration: underline;
}

.footerFont{
    font-family: "Abel", serif;
    font-size: 18px;
    letter-spacing: 1px;
    color: #cccccc;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-right: 5px;
    margin-left: 5px;
}

.headerFont{
    font-family: "Josefin Sans", serif;
    font-size: 15px;
    font-weight: 600;
    /* letter-spacing: .5px; */
    color: #cccccc;
    margin-top: 15px;
    margin-bottom: 5px;
    margin-right: 5px;
    margin-left: 5px;
    /* padding-bottom: 15px; */
}


/* a:link {
    text-decoration: none;
    color: #cccccc;
  }
  
  a:visited {
    text-decoration: none;
    color: #cccccc;
  }
  
  a:hover {
    text-decoration: underline;
    color: #cccccc;
  }
  
  a:active {
    text-decoration: underline;
    color: #cccccc;
  } */
  

/* ------------------------------parts------------------------------ */

#container {
    width: 100%;
    height: 100%;
    /* background-color: black;
    border: 1px solid red; */
}

#container900 {
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
}

#mainDiv #container900 {
    display: flex;
    flex-direction: column;
    gap: 9px;
}

#mainDiv #container900 > .spacer2 {
    display: none;
}

#mainDiv #container900 > .spacer10 {
    display: flex;
    margin-top: -9px;
    margin-bottom: -9px;
}

#mainDiv #container900 > .greyLine,
#mainDiv #container900 > .greyLine2 {
    display: none;
}

#mainDiv #container900 > .textDiv {
    margin: 0;
}

#mainDiv #container900 > .textDiv.center:has(img[src*="tri.svg"]) {
    margin-top: 17px;
    margin-bottom: 9px;
}

body.crt-bg-active #mainDiv #container900,
body.crt-bg-active #mainDiv .reelContainer {
    background: rgba(0, 0, 0, 0.0);
    box-shadow: 0 0 0 15px rgba(0, 0, 0, 0);
    box-sizing: border-box;
}

.greyLine {
    width: 100%;
    border-top: 1px solid #333333;
    background-color: #333333;
    margin-top: 4px;
    margin-bottom: 6px;
    z-index: 10;
}
  
.greyLine2 {
    width: 100%;
    border-top: 1px solid #333333;
    background-color: #333333;
    margin-top: 4px;
    margin-bottom: 6px;
    z-index: 10;
    transform: translateY(9px);
    display: none;
}
  
.imageCont{
    display: block;
}

.imageCont svg.imageFull text,
.imageCont svg.imageFull tspan {
    font-family: Arial, Helvetica, sans-serif !important;
}

.imageSplit{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
}
  
.imageContHalf {
    display: flex;
    gap: 4px;
    /* border: 1px solid red; */
}

.gameSystemsSixPack {
    display: flex;
    gap: 6px;
}

.gameSystemsSixPackImage {
    width: calc((100% - 24px) / 5);
    max-width: 177px;
    overflow: hidden;
    margin-bottom: 5px;
}

.imageFull {
    width: 100%;
    max-width: 900px;

    float: none;

    overflow: hidden;
    /* border: 1px solid blue; */
}

.imageHalf {
    width: 50%;
    max-width: 450px;
  
    /* float: left; */
    
    overflow: hidden;
    margin-bottom: 5px;
}

.imagePart {
    max-width: 450px;
  
    /* float: left;
     */
    overflow: hidden;
    margin-bottom: 5px;

    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
}

.blackBorder{
    /* border: 2px solid rgb(0, 0, 0, .25); */
    /* border: 1px solid #111111; */
    /* box-shadow: inset 111 111 130px rgba(0, 0, 0, 1); */
    /* box-shadow: inset 15px 15px 15px rgba(0, 0, 0, 1); */
}

.textDiv {
    padding-top: 4px;
    padding-bottom: 2px;
    margin-top: 7px;
    margin-bottom: 9px;
    z-index: 10000;
}

#mainDiv .textDiv.lineBorders,
#mainDiv .linkDiv {
    background: rgba(0, 0, 0, 0.9);
    border: 1px solid #444444;
    border-radius: 0;
    padding: 14px 18px;
    box-sizing: border-box;
    margin: 0;
}

#mainDiv .textDiv.center:has(.footerFont),
#mainDiv .imageDiv.center:has(.footerFont) {
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
}

#mainDiv .textDiv.lineBorders {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

#mainDiv .textDiv.lineBorders::before,
#mainDiv .textDiv.lineBorders::after {
    content: "";
    display: block;
    width: 4.7px;
    height: 4.7px;
    background-color: #686868;
    transform: rotate(45deg);
    flex-shrink: 0;
}

#mainDiv .textDiv.lineBorders::before {
    margin-bottom: 0px;
}

#mainDiv .textDiv.lineBorders::after {
    margin-top: -8px;
}

#mainDiv .textDiv.lineBorders .serifFont,
#mainDiv .textDiv.lineBorders.justify,
#mainDiv .textDiv.lineBorders.center,
#mainDiv .textDiv.lineBorders .serifFont p {
    width: 100%;
    text-align: center;
}

/* ------------------------------ print page ------------------------------ */

#mainDiv #container2 {
    width: 100%;
    max-width: 800px;
    height: auto;
    margin: 0 auto;
}

#mainDiv #container2 .topDiv,
#mainDiv #container2 .topDiv.headerFont {
    background: transparent;
    border: none;
    border-radius: 0;
    padding: 0;
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    width: 100%;
    box-sizing: border-box;
}

#mainDiv #container2 .textDivPrint2 {
    background: transparent;
    border: none;
    border-radius: 0;
    padding: 0;
    margin-top: 12px;
    margin-bottom: 12px;
    text-align: justify;
    text-align-last: center;
    max-width: 800px;
    width: 100%;
    box-sizing: border-box;
}

#mainDiv #container2 .textDivPrint,
#mainDiv #container2 .textDivPrint3 {
    background: transparent;
    border: none;
    border-radius: 0;
    padding: 0;
    box-sizing: border-box;
}

#mainDiv #container2 .italicScript {
    color: #cccccc;
}

#mainDiv .textDiv.lineBorders.textDivDown,
#mainDiv .textDiv.lineBorders.textDivUp {
    transform: none;
}

#mainDiv #container900 > .imageCont {
    display: flex;
    flex-direction: column;
    gap: 9px;
    margin: 0;
}

#mainDiv #container900 > .imageContHalf,
#mainDiv #container900 > .imageSplit,
#mainDiv #container900 > .gameSystemsSixPack,
#mainDiv #container900 > .videoContainer {
    margin: 0;
}

#mainDiv #container900 > .videoContainer {
    margin-left: auto;
    margin-right: auto;
}

#mainDiv #container900 .imageHalf,
#mainDiv #container900 .imagePart,
#mainDiv #container900 .gameSystemsSixPackImage {
    margin-bottom: 0;
}

#mainDiv #container900 > .dbar-parent {
    background: none !important;
    background-color: rgba(0, 0, 0, 0) !important;
    box-shadow: none;
    border: none;
    border-radius: 0;
    height: auto;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

#mainDiv .dbar-parent {
    height: auto;
    min-height: 28px;
}

#mainDiv .textDiv .serifFont p {
    margin-top: 0;
    margin-bottom: 12px;
}

#mainDiv .textDiv .serifFont p:last-child {
    margin-bottom: 0;
}

/* ------------------------------video------------------------------ */

.reelContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    max-width: 900px;
    margin: 0 auto;
}

.reelPlayer {
    position: relative;
    width: 100%;
    max-width: 900px;
}

.reelVideo {
    display: block;
    width: 100%;
    max-width: 900px;
    aspect-ratio: 16 / 9;
    border: none;
    background: #000000;
}

.reelOverlay {
    position: absolute;
    inset: 0;
    cursor: pointer;
    z-index: 15;
}

.reelPlayer.has-started .reelOverlay {
    display: none;
}

.reelPlaceholderImage {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.reelOverlayShade {
    position: absolute;
    inset: 0;
    background: transparent;
}

.reelOverlayPlayIcon {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 84px;
    height: 84px;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.9);
    background: rgba(0, 0, 0, 0.45);
}

.reelOverlayPlayIcon::before {
    content: "";
    position: absolute;
    left: 34px;
    top: 27px;
    width: 0;
    height: 0;
    border-top: 14px solid transparent;
    border-bottom: 14px solid transparent;
    border-left: 23px solid #ffffff;
}


.videoContainer {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    width: 100%;
    max-width: 900px;
    margin: 0;
    border: 1px solid #333333;
  }
  
  .videoInner {
    max-width: 900px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .videoInner iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }

  .video {
    width: 100%;
    height: 100%;
  }

.gameSystemsHero {
    position: relative;
}

.gameSystemsPlayButton {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 84px;
    height: 84px;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.9);
    background: rgba(0, 0, 0, 0.45);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    transition: transform 0.2s ease, background-color 0.2s ease;
}

.gameSystemsPlayButton:hover {
    transform: translate(-50%, -50%) scale(1.05);
    background: rgba(0, 0, 0, 0.62);
}

.gameSystemsPlayTriangle {
    display: block;
    width: 0;
    height: 0;
    margin-left: 4px;
    border-top: 14px solid transparent;
    border-bottom: 14px solid transparent;
    border-left: 23px solid #ffffff;
}

.gameSystemsVideoOverlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.72);
    z-index: 500000;
    display: none;
    opacity: 0;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.gameSystemsVideoOverlay.is-open {
    display: flex;
}

.gameSystemsVideoPlayer {
    width: auto;
    height: 95vh;
    max-width: 95vw;
    border: 1px solid #222222;
    background: #000000;
    cursor: auto;
}
  
/* ------------------------------add ons------------------------------ */

.lineBorders{
    border-top: 1px solid #333333;
    border-bottom: 1px solid #333333;
    width: 100%;
    display: block;
}
  
.thumb {
    -moz-border-radius: 8px;
    -webkit-border-radius: 8px;
    border-radius: 8px;
}
  
.greyBorder{
    border: 1px solid grey;
}

.center{
    text-align: center;
}

.justify{
    text-align: justify;
}

.linkDiv{
    text-align: center;
}

.topSpacer {
    position: relative;
    display: flex;
    padding: 45px;
  }
    
.spacer2 {
    position: relative;
    display: flex;
    padding: 2px;
  }
    
.spacer10 {
    position: relative;
    display: flex;
    padding: 10px;
}

/* ------------------------------canvas------------------------------ */

.backCanvas{
    position: absolute;
    overflow: hidden;
}

/* ------------------------------specail------------------------------ */

.characterBlock {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.contCharacter{
    height: 250px;
}

/* ------------------------------dbar------------------------------ */

.dbar-projectFont{
    font-family: "Rajdhani", sans-serif;
    font-weight: 600;
    letter-spacing: 1px;
    color: #cccccc;
    font-size: 8pt;
    margin-right: 6px;
}

.dbar-launchFont{
    font-family: "Rajdhani", sans-serif;
    font-weight: 600;
    letter-spacing: 1px;
    color: #cccccc;
    font-size: 8pt;
    padding-right: 4px;
    display: block;
}

.dbar-link a:link, .dbar-link a:visited {
    text-decoration: none;
    color: #cccccc; /* Set the color for normal state */
}

.dbar-link a:hover {
    text-decoration: underline;
    color: #ffffff; /* Set the color when hovered */
}

.dbar-link a:active {
    text-decoration: underline;
    color: #ffffff; /* Same color as hover when active */
}

/* Links inside .regularFont */
.regularFont a:link, .regularFont a:visited {
    text-decoration: none;
    color: #666666;  /* Color for links in regularFont */
}

.regularFont a:hover {
    text-decoration: underline;
    color: #ff6600;  /* Different color for hover effect */
}

.regularFont a:active {
    text-decoration: underline;
    color: #ff6600;  /* Same color as hover */
}


.dbar-formatName{
    font-family: "Josefin Sans", sans-serif;
    font-weight: 300;
    letter-spacing: 1px;
    color: #cccccc;
    font-size: 18pt;
    margin-right: 8px;
    transform: translateY(1px);
}

.dbar-formatFont{
    font-family: "Rajdhani", sans-serif;
    font-weight: 600;
    letter-spacing: 1px;
    color: #cccccc;
    font-size: 8pt;
    margin-right: 10px;
}

.dbar-link {
    font-family: "Rajdhani", sans-serif;
    font-weight: 500;
    letter-spacing: 1px;
    color: #cccccc;
    font-size: 13pt;
    transform: translateY(-2px);
    text-decoration: none;
}

.dbar-parent {
    display: flex;
  
    width: 100%;
    height: 28px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    position: relative;
    margin-top: 4px;
    /* border: 1px solid red; */
    /* border-bottom: 1px solid grey; */
}

.dbar-diag {
    position: absolute;
    top: 22px;
    left: 0;
    transform: translateY(5px);
    /* width: 40px; */
    height: auto;
    pointer-events: none;
    display: none;
}

.dbar-left-section, .dbar-right-section {
    display: flex;
    align-items: center;
    /* border: 1px solid red; */
}

.dbar-left-line {
    width: 20px;
    height: 1px;
    background: #686868;
    margin-right: 6px;
    transform: translateY(-2px);
}

.dbar-left-text {
    display: flex;
    align-items: center;
}

.dbar-middle-line {
    flex-grow: 1;
    height: 1px;
    background: #686868;
    /* margin: 0 2px; */
    transform: translateY(-2px);
}

.dbar-right-text {
    display: flex;
    align-items: center;
    margin-left: 10px;
}

.dbar-right-text span {
    margin-right: 5px;
}

.dbar-right-text .dbar-small {
    font-size: 10pt;
}

.dbar-right-text{
    font-size: 22pt;
    margin-left: 10px;
    cursor: pointer;
    /* text-decoration: underline; */
}

/* ------------------------------perfect strangers------------------------------ */

.ps-font1{
    font-family: "Rajdhani", sans-serif;
    font-size: 14px;
    letter-spacing: 1px;
    color: #cccccc;
}

.ps-font2{
    font-family: "Rajdhani", sans-serif;
    font-size: 18px;
    letter-spacing: 1px;
    color: #cccccc;
}

.ps-container {
    display: flex;
    width: 100%;
    height: 420px;
}

.ps-column {
    display: flex;
    flex-direction: column;
    padding: 10px;
    width: 100%;
}

.ps-topDiv {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.ps-topDiv img {
    width: 60px;
    height: 60px;
    object-fit: cover;
    margin-right: 10px;
}

.ps-textContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.ps-topText {
    
}

.ps-bottomText {
    
}

.ps-bottomDiv {
    margin-top: 10px;
    text-align: justify;
}

#mainDiv .imageSplit.center {
    justify-content: center;
    align-items: center;
    width: 100%;
}

#mainDiv .imageSplit.center > img {
    display: block;
}

/* ------------------------------mobile------------------------------ */

@media (max-width: 715px) {
    .textDiv {
      padding-left: 8px;
      padding-right: 8px;
    }
    .lineBorders {
      border-top: 0px solid grey;
      border-bottom: 0px solid grey;
    }

    #mainDiv .textDiv.lineBorders,
    #mainDiv .linkDiv {
      background: transparent;
      border: none;
    }

    #mainDiv .textDiv.center:has(.footerFont),
    #mainDiv .imageDiv.center:has(.footerFont) {
      background: transparent;
      border: none;
    }
    .image900 {
      border-radius: 0px;
    }
    .thumb {
      border-radius: 0px;
      margin: 0px;
      padding: 0px;
      /* margin-bottom: 2px; */
      /* border: 1px solid yellow; */
    }
    .imageContHalf,
    .imageSplit {
      flex-direction: column;
      gap: 9px;
    }

    .imageSplit.center:has(.characterBlock) {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 9px;
      width: 100%;
      justify-items: center;
      align-items: start;
    }

    .imageSplit.center:has(.characterBlock) .characterBlock {
      width: 100%;
    }

    .imageSplit.center:has(.characterBlock) .contCharacter {
      height: auto;
      width: 100%;
      max-width: 100%;
      object-fit: cover;
    }

    #mainDiv #container900 > .imageCont,
    #mainDiv #container900 > .imageContHalf,
    #mainDiv #container900 > .imageSplit,
    #mainDiv #container900 > .gameSystemsSixPack {
      gap: 9px;
    }

    .imageHalf {
      width: 100%;
      margin-bottom: 0;
    }
    .gameSystemsSixPack {
      flex-direction: row;
      flex-wrap: wrap;
      gap: 9px;
      justify-content: center;
    }
    .gameSystemsSixPackImage {
      flex: 0 0 calc((100% - 9px) / 2);
      width: calc((100% - 9px) / 2);
      max-width: none;
      margin-bottom: 0;
    }
    .gameSystemsSixPackImage:nth-child(5) {
      display: none;
    }
    #mainDiv #container900 > .dbar-parent {
      margin-bottom: 0;
    }
    .imagePart {
      display: none;
    }
    .greyBorder {
      border: 0px solid grey;
    }
    .dbar-parent {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin-bottom: 0;
      width: 100%;
      box-sizing: border-box;
      /* border: 1px solid green; */
    }
    .dbar-left-section,
    .dbar-right-section {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      /* border: 1px solid blue; */
    }
    .dbar-left-text,
    .dbar-right-text {
      display: flex;
      /* flex-direction: column; */
      align-items: center;
      margin: 0;
      padding: 0;
    }
    .dbar-left-text span,
    .dbar-right-text span {
      display: block;
      margin: 0 0;
      text-align: center;
    }
    .dbar-left-line {
      display: none;
      order: 0;
      width: 20px;
      height: 1px;
      background: #686868;
    }
    .dbar-formatName {
      order: 1;
      transform: none !important;
      text-align: center;
      margin: 0;
      padding: 0;
      /* border: 1px solid red; */
    }
    .dbar-middle-line {
      display: none;
      order: 2;
      width: 20px;
      height: 1px;
      background: #686868;
    }
    .dbar-link {
      transform: none !important;
      text-align: center;
      margin: 0;
      padding: 2px;
      font-size: 15px;
      /* text-decoration: underline; */
    }
    .dbar-diag {
      display: none;
    }
    .dbar-launchFont {
      display: none !important;
    }
    .dbar-projectFont {
      display: none !important;
    }
    .dbar-formatFont {
      display: none !important;
    }
    .pressLink {
      margin-left: 0;
      margin-right: 0;
      padding: 0;
    }
    .linkDiv {
      text-align: center;
      padding: 0;
      margin: 0 auto;
      transform: translateY(2px);
    }

    .linkDiv.divPar {
      width: 100%;
      max-width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      gap: 4px 8px;
    }
    .nothingHide{
        display:none !important;
    }
    .nothingHide2{
        height: 4px;
    }
    .greyLine2 {
        display: block;
    }
    .textDivDown{
        transform: translateY(5px);
    }
    .textDivUp{
        transform: translateY(-3px);
    }
    .videoContainer{
        border: none;
    }
    .ps-container{
        display: none;
    }
    .divPar{
        width: 100%;
        max-width: 100%;
    }
    .mobileLogo{
        width: 70%;
    }
  }

  `, "",{"version":3,"sources":["webpack://./src/page.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA,sEAAsE;;AAEtE;IACI,mCAAmC;IACnC,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;AAEF;IACI,4BAA4B;IAC5B,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;;;;EAKE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;;;;EAKE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;AAC9B;;;AAGA;;;;;;;;;;;;;;;;;;KAkBK;;;AAGL,sEAAsE;;AAEtE;IACI,WAAW;IACX,YAAY;IACZ;4BACwB;AAC5B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,8BAA8B;IAC9B,uCAAuC;IACvC,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;;IAEhB,WAAW;;IAEX,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,gBAAgB;;IAEhB,iBAAiB;;IAEjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;;IAEhB;MACE;IACF,gBAAgB;IAChB,kBAAkB;;IAElB,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,yCAAyC;IACzC,+BAA+B;IAC/B,sDAAsD;IACtD,uDAAuD;AAC3D;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;IAEI,8BAA8B;IAC9B,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;AACb;;AAEA;;IAEI,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;;IAII,WAAW;IACX,kBAAkB;AACtB;;AAEA,6EAA6E;;AAE7E;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,cAAc;AAClB;;AAEA;;IAEI,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;;IAEI,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,SAAS;AACb;;AAEA;;;;IAII,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;;IAGI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;IAC7C,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,sEAAsE;;AAEtE;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,0CAA0C;IAC1C,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,qCAAqC;IACrC,+BAA+B;AACnC;;;AAGA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;AAEF;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,0CAA0C;IAC1C,+BAA+B;IAC/B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,2DAA2D;AAC/D;;AAEA;IACI,4CAA4C;IAC5C,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,kCAAkC;IAClC,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,eAAe;IACf,aAAa;IACb,UAAU;IACV,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA,wEAAwE;;AAExE;IACI,6BAA6B;IAC7B,gCAAgC;IAChC,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;EACf;;AAEF;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;EACd;;AAEF;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;AACjB;;AAEA,uEAAuE;;AAEvE;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,wEAAwE;;AAExE;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA,qEAAqE;;AAErE;IACI,mCAAmC;IACnC,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc,EAAE,mCAAmC;AACvD;;AAEA;IACI,0BAA0B;IAC1B,cAAc,EAAE,+BAA+B;AACnD;;AAEA;IACI,0BAA0B;IAC1B,cAAc,EAAE,oCAAoC;AACxD;;AAEA,8BAA8B;AAC9B;IACI,qBAAqB;IACrB,cAAc,GAAG,mCAAmC;AACxD;;AAEA;IACI,0BAA0B;IAC1B,cAAc,GAAG,qCAAqC;AAC1D;;AAEA;IACI,0BAA0B;IAC1B,cAAc,GAAG,wBAAwB;AAC7C;;;AAGA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,aAAa;;IAEb,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,0BAA0B;IAC1B,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,gCAAgC;AACpC;;AAEA,kFAAkF;;AAElF;IACI,mCAAmC;IACnC,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA,uEAAuE;;AAEvE;IACI;MACE,iBAAiB;MACjB,kBAAkB;IACpB;IACA;MACE,0BAA0B;MAC1B,6BAA6B;IAC/B;;IAEA;;MAEE,uBAAuB;MACvB,YAAY;IACd;;IAEA;;MAEE,uBAAuB;MACvB,YAAY;IACd;IACA;MACE,kBAAkB;IACpB;IACA;MACE,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,wBAAwB;MACxB,8BAA8B;IAChC;IACA;;MAEE,sBAAsB;MACtB,QAAQ;IACV;;IAEA;MACE,aAAa;MACb,qCAAqC;MACrC,QAAQ;MACR,WAAW;MACX,qBAAqB;MACrB,kBAAkB;IACpB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,YAAY;MACZ,WAAW;MACX,eAAe;MACf,iBAAiB;IACnB;;IAEA;;;;MAIE,QAAQ;IACV;;IAEA;MACE,WAAW;MACX,gBAAgB;IAClB;IACA;MACE,mBAAmB;MACnB,eAAe;MACf,QAAQ;MACR,uBAAuB;IACzB;IACA;MACE,gCAAgC;MAChC,6BAA6B;MAC7B,eAAe;MACf,gBAAgB;IAClB;IACA;MACE,aAAa;IACf;IACA;MACE,gBAAgB;IAClB;IACA;MACE,aAAa;IACf;IACA;MACE,sBAAsB;IACxB;IACA;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,kBAAkB;MAClB,gBAAgB;MAChB,WAAW;MACX,sBAAsB;MACtB,6BAA6B;IAC/B;IACA;;MAEE,WAAW;MACX,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,sBAAsB;MACtB,4BAA4B;IAC9B;IACA;;MAEE,aAAa;MACb,4BAA4B;MAC5B,mBAAmB;MACnB,SAAS;MACT,UAAU;IACZ;IACA;;MAEE,cAAc;MACd,WAAW;MACX,kBAAkB;IACpB;IACA;MACE,aAAa;MACb,QAAQ;MACR,WAAW;MACX,WAAW;MACX,mBAAmB;IACrB;IACA;MACE,QAAQ;MACR,0BAA0B;MAC1B,kBAAkB;MAClB,SAAS;MACT,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,aAAa;MACb,QAAQ;MACR,WAAW;MACX,WAAW;MACX,mBAAmB;IACrB;IACA;MACE,0BAA0B;MAC1B,kBAAkB;MAClB,SAAS;MACT,YAAY;MACZ,eAAe;MACf,gCAAgC;IAClC;IACA;MACE,aAAa;IACf;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,cAAc;MACd,eAAe;MACf,UAAU;IACZ;IACA;MACE,kBAAkB;MAClB,UAAU;MACV,cAAc;MACd,0BAA0B;IAC5B;;IAEA;MACE,WAAW;MACX,eAAe;MACf,aAAa;MACb,eAAe;MACf,uBAAuB;MACvB,mBAAmB;MACnB,YAAY;IACd;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,WAAW;IACf;IACA;QACI,cAAc;IAClB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,YAAY;IAChB;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,UAAU;IACd;EACF","sourcesContent":["* {\n    box-sizing: border-box;\n}\n\n/* ------------------------------fonts------------------------------ */\n\n.regularFont {\n    font-family: \"Rajdhani\", sans-serif;\n    font-weight: 600;\n    font-size: 11px;\n    letter-spacing: 1px;\n    color: #666666;\n    padding-left: 14px;\n}\n  \n.scriptFont {\n    font-family: \"IM Fell English\", serif;\n    font-size: 16px;\n    color: #666666;\n    /* letter-spacing: 1px; */\n    font-style: italic;\n}\n\n.italicScript {\n    font-family: \"IM Fell English\", serif;\n    font-size: 15px;\n    color: #cccccc;\n    letter-spacing: 0px;\n    line-height: 20px;\n    font-style: italic;\n    margin-top: 0px;\n  }\n  \n.serifFont{\n    font-family: \"Radley\", serif;\n    font-size: 13px;\n    color: #cccccc;\n    letter-spacing: 0px;\n    margin-top: 8px;\n    margin-bottom: 16px;\n}\n\n.pageLink {\n    font-family: \"Rajdhani\", sans-serif;\n    font-size: 20px;\n    letter-spacing: 1px;\n    color: #cccccc;\n    margin-top: 5px;\n    margin-bottom: 5px;\n    margin-right: 5px;\n    margin-left: 5px;\n}\n\n.pressLink {\n    font-family: \"Rajdhani\", sans-serif;\n    font-size: 14px;\n    letter-spacing: 1px;\n    color: #cccccc;\n    margin-top: 5px;\n    margin-bottom: 5px;\n    margin-right: 2px;\n    margin-left: 2px;\n}\n\n.pressLink a,\n.pressLink a:link,\n.pressLink a:visited,\n.pressLink a:hover,\n.pressLink a:active {\n  color: #cccccc;\n  text-decoration: underline;\n}\n\n#contactLink,\n#contactLink:link,\n#contactLink:visited,\n#contactLink:hover,\n#contactLink:active {\n  color: #cccccc;\n  text-decoration: underline;\n}\n\n.footerFont{\n    font-family: \"Abel\", serif;\n    font-size: 18px;\n    letter-spacing: 1px;\n    color: #cccccc;\n    margin-top: 5px;\n    margin-bottom: 5px;\n    margin-right: 5px;\n    margin-left: 5px;\n}\n\n.headerFont{\n    font-family: \"Josefin Sans\", serif;\n    font-size: 15px;\n    font-weight: 600;\n    /* letter-spacing: .5px; */\n    color: #cccccc;\n    margin-top: 15px;\n    margin-bottom: 5px;\n    margin-right: 5px;\n    margin-left: 5px;\n    /* padding-bottom: 15px; */\n}\n\n\n/* a:link {\n    text-decoration: none;\n    color: #cccccc;\n  }\n  \n  a:visited {\n    text-decoration: none;\n    color: #cccccc;\n  }\n  \n  a:hover {\n    text-decoration: underline;\n    color: #cccccc;\n  }\n  \n  a:active {\n    text-decoration: underline;\n    color: #cccccc;\n  } */\n  \n\n/* ------------------------------parts------------------------------ */\n\n#container {\n    width: 100%;\n    height: 100%;\n    /* background-color: black;\n    border: 1px solid red; */\n}\n\n#container900 {\n    width: 100%;\n    max-width: 900px;\n    margin: 0 auto;\n}\n\n#mainDiv #container900 {\n    display: flex;\n    flex-direction: column;\n    gap: 9px;\n}\n\n#mainDiv #container900 > .spacer2 {\n    display: none;\n}\n\n#mainDiv #container900 > .spacer10 {\n    display: flex;\n    margin-top: -9px;\n    margin-bottom: -9px;\n}\n\n#mainDiv #container900 > .greyLine,\n#mainDiv #container900 > .greyLine2 {\n    display: none;\n}\n\n#mainDiv #container900 > .textDiv {\n    margin: 0;\n}\n\n#mainDiv #container900 > .textDiv.center:has(img[src*=\"tri.svg\"]) {\n    margin-top: 17px;\n    margin-bottom: 9px;\n}\n\nbody.crt-bg-active #mainDiv #container900,\nbody.crt-bg-active #mainDiv .reelContainer {\n    background: rgba(0, 0, 0, 0.0);\n    box-shadow: 0 0 0 15px rgba(0, 0, 0, 0);\n    box-sizing: border-box;\n}\n\n.greyLine {\n    width: 100%;\n    border-top: 1px solid #333333;\n    background-color: #333333;\n    margin-top: 4px;\n    margin-bottom: 6px;\n    z-index: 10;\n}\n  \n.greyLine2 {\n    width: 100%;\n    border-top: 1px solid #333333;\n    background-color: #333333;\n    margin-top: 4px;\n    margin-bottom: 6px;\n    z-index: 10;\n    transform: translateY(9px);\n    display: none;\n}\n  \n.imageCont{\n    display: block;\n}\n\n.imageCont svg.imageFull text,\n.imageCont svg.imageFull tspan {\n    font-family: Arial, Helvetica, sans-serif !important;\n}\n\n.imageSplit{\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n  \n.imageContHalf {\n    display: flex;\n    gap: 4px;\n    /* border: 1px solid red; */\n}\n\n.gameSystemsSixPack {\n    display: flex;\n    gap: 6px;\n}\n\n.gameSystemsSixPackImage {\n    width: calc((100% - 24px) / 5);\n    max-width: 177px;\n    overflow: hidden;\n    margin-bottom: 5px;\n}\n\n.imageFull {\n    width: 100%;\n    max-width: 900px;\n\n    float: none;\n\n    overflow: hidden;\n    /* border: 1px solid blue; */\n}\n\n.imageHalf {\n    width: 50%;\n    max-width: 450px;\n  \n    /* float: left; */\n    \n    overflow: hidden;\n    margin-bottom: 5px;\n}\n\n.imagePart {\n    max-width: 450px;\n  \n    /* float: left;\n     */\n    overflow: hidden;\n    margin-bottom: 5px;\n\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.blackBorder{\n    /* border: 2px solid rgb(0, 0, 0, .25); */\n    /* border: 1px solid #111111; */\n    /* box-shadow: inset 111 111 130px rgba(0, 0, 0, 1); */\n    /* box-shadow: inset 15px 15px 15px rgba(0, 0, 0, 1); */\n}\n\n.textDiv {\n    padding-top: 4px;\n    padding-bottom: 2px;\n    margin-top: 7px;\n    margin-bottom: 9px;\n    z-index: 10000;\n}\n\n#mainDiv .textDiv.lineBorders,\n#mainDiv .linkDiv {\n    background: rgba(0, 0, 0, 0.9);\n    border: 1px solid #444444;\n    border-radius: 0;\n    padding: 14px 18px;\n    box-sizing: border-box;\n    margin: 0;\n}\n\n#mainDiv .textDiv.center:has(.footerFont),\n#mainDiv .imageDiv.center:has(.footerFont) {\n    background: transparent;\n    border: none;\n    padding: 0;\n    margin: 0;\n}\n\n#mainDiv .textDiv.lineBorders {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n}\n\n#mainDiv .textDiv.lineBorders::before,\n#mainDiv .textDiv.lineBorders::after {\n    content: \"\";\n    display: block;\n    width: 4.7px;\n    height: 4.7px;\n    background-color: #686868;\n    transform: rotate(45deg);\n    flex-shrink: 0;\n}\n\n#mainDiv .textDiv.lineBorders::before {\n    margin-bottom: 0px;\n}\n\n#mainDiv .textDiv.lineBorders::after {\n    margin-top: -8px;\n}\n\n#mainDiv .textDiv.lineBorders .serifFont,\n#mainDiv .textDiv.lineBorders.justify,\n#mainDiv .textDiv.lineBorders.center,\n#mainDiv .textDiv.lineBorders .serifFont p {\n    width: 100%;\n    text-align: center;\n}\n\n/* ------------------------------ print page ------------------------------ */\n\n#mainDiv #container2 {\n    width: 100%;\n    max-width: 800px;\n    height: auto;\n    margin: 0 auto;\n}\n\n#mainDiv #container2 .topDiv,\n#mainDiv #container2 .topDiv.headerFont {\n    background: transparent;\n    border: none;\n    border-radius: 0;\n    padding: 0;\n    margin-top: 20px;\n    margin-bottom: 20px;\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n#mainDiv #container2 .textDivPrint2 {\n    background: transparent;\n    border: none;\n    border-radius: 0;\n    padding: 0;\n    margin-top: 12px;\n    margin-bottom: 12px;\n    text-align: justify;\n    text-align-last: center;\n    max-width: 800px;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n#mainDiv #container2 .textDivPrint,\n#mainDiv #container2 .textDivPrint3 {\n    background: transparent;\n    border: none;\n    border-radius: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n#mainDiv #container2 .italicScript {\n    color: #cccccc;\n}\n\n#mainDiv .textDiv.lineBorders.textDivDown,\n#mainDiv .textDiv.lineBorders.textDivUp {\n    transform: none;\n}\n\n#mainDiv #container900 > .imageCont {\n    display: flex;\n    flex-direction: column;\n    gap: 9px;\n    margin: 0;\n}\n\n#mainDiv #container900 > .imageContHalf,\n#mainDiv #container900 > .imageSplit,\n#mainDiv #container900 > .gameSystemsSixPack,\n#mainDiv #container900 > .videoContainer {\n    margin: 0;\n}\n\n#mainDiv #container900 > .videoContainer {\n    margin-left: auto;\n    margin-right: auto;\n}\n\n#mainDiv #container900 .imageHalf,\n#mainDiv #container900 .imagePart,\n#mainDiv #container900 .gameSystemsSixPackImage {\n    margin-bottom: 0;\n}\n\n#mainDiv #container900 > .dbar-parent {\n    background: none !important;\n    background-color: rgba(0, 0, 0, 0) !important;\n    box-shadow: none;\n    border: none;\n    border-radius: 0;\n    height: auto;\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n}\n\n#mainDiv .dbar-parent {\n    height: auto;\n    min-height: 28px;\n}\n\n#mainDiv .textDiv .serifFont p {\n    margin-top: 0;\n    margin-bottom: 12px;\n}\n\n#mainDiv .textDiv .serifFont p:last-child {\n    margin-bottom: 0;\n}\n\n/* ------------------------------video------------------------------ */\n\n.reelContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    max-width: 900px;\n    margin: 0 auto;\n}\n\n.reelPlayer {\n    position: relative;\n    width: 100%;\n    max-width: 900px;\n}\n\n.reelVideo {\n    display: block;\n    width: 100%;\n    max-width: 900px;\n    aspect-ratio: 16 / 9;\n    border: none;\n    background: #000000;\n}\n\n.reelOverlay {\n    position: absolute;\n    inset: 0;\n    cursor: pointer;\n    z-index: 15;\n}\n\n.reelPlayer.has-started .reelOverlay {\n    display: none;\n}\n\n.reelPlaceholderImage {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.reelOverlayShade {\n    position: absolute;\n    inset: 0;\n    background: transparent;\n}\n\n.reelOverlayPlayIcon {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 84px;\n    height: 84px;\n    transform: translate(-50%, -50%);\n    border-radius: 50%;\n    border: 2px solid rgba(255, 255, 255, 0.9);\n    background: rgba(0, 0, 0, 0.45);\n}\n\n.reelOverlayPlayIcon::before {\n    content: \"\";\n    position: absolute;\n    left: 34px;\n    top: 27px;\n    width: 0;\n    height: 0;\n    border-top: 14px solid transparent;\n    border-bottom: 14px solid transparent;\n    border-left: 23px solid #ffffff;\n}\n\n\n.videoContainer {\n    position: relative;\n    padding-bottom: 56.25%;\n    height: 0;\n    width: 100%;\n    max-width: 900px;\n    margin: 0;\n    border: 1px solid #333333;\n  }\n  \n  .videoInner {\n    max-width: 900px;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n\n  .videoInner iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: none;\n  }\n\n  .video {\n    width: 100%;\n    height: 100%;\n  }\n\n.gameSystemsHero {\n    position: relative;\n}\n\n.gameSystemsPlayButton {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 84px;\n    height: 84px;\n    transform: translate(-50%, -50%);\n    border-radius: 50%;\n    border: 2px solid rgba(255, 255, 255, 0.9);\n    background: rgba(0, 0, 0, 0.45);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10;\n    transition: transform 0.2s ease, background-color 0.2s ease;\n}\n\n.gameSystemsPlayButton:hover {\n    transform: translate(-50%, -50%) scale(1.05);\n    background: rgba(0, 0, 0, 0.62);\n}\n\n.gameSystemsPlayTriangle {\n    display: block;\n    width: 0;\n    height: 0;\n    margin-left: 4px;\n    border-top: 14px solid transparent;\n    border-bottom: 14px solid transparent;\n    border-left: 23px solid #ffffff;\n}\n\n.gameSystemsVideoOverlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.72);\n    z-index: 500000;\n    display: none;\n    opacity: 0;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n}\n\n.gameSystemsVideoOverlay.is-open {\n    display: flex;\n}\n\n.gameSystemsVideoPlayer {\n    width: auto;\n    height: 95vh;\n    max-width: 95vw;\n    border: 1px solid #222222;\n    background: #000000;\n    cursor: auto;\n}\n  \n/* ------------------------------add ons------------------------------ */\n\n.lineBorders{\n    border-top: 1px solid #333333;\n    border-bottom: 1px solid #333333;\n    width: 100%;\n    display: block;\n}\n  \n.thumb {\n    -moz-border-radius: 8px;\n    -webkit-border-radius: 8px;\n    border-radius: 8px;\n}\n  \n.greyBorder{\n    border: 1px solid grey;\n}\n\n.center{\n    text-align: center;\n}\n\n.justify{\n    text-align: justify;\n}\n\n.linkDiv{\n    text-align: center;\n}\n\n.topSpacer {\n    position: relative;\n    display: flex;\n    padding: 45px;\n  }\n    \n.spacer2 {\n    position: relative;\n    display: flex;\n    padding: 2px;\n  }\n    \n.spacer10 {\n    position: relative;\n    display: flex;\n    padding: 10px;\n}\n\n/* ------------------------------canvas------------------------------ */\n\n.backCanvas{\n    position: absolute;\n    overflow: hidden;\n}\n\n/* ------------------------------specail------------------------------ */\n\n.characterBlock {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.contCharacter{\n    height: 250px;\n}\n\n/* ------------------------------dbar------------------------------ */\n\n.dbar-projectFont{\n    font-family: \"Rajdhani\", sans-serif;\n    font-weight: 600;\n    letter-spacing: 1px;\n    color: #cccccc;\n    font-size: 8pt;\n    margin-right: 6px;\n}\n\n.dbar-launchFont{\n    font-family: \"Rajdhani\", sans-serif;\n    font-weight: 600;\n    letter-spacing: 1px;\n    color: #cccccc;\n    font-size: 8pt;\n    padding-right: 4px;\n    display: block;\n}\n\n.dbar-link a:link, .dbar-link a:visited {\n    text-decoration: none;\n    color: #cccccc; /* Set the color for normal state */\n}\n\n.dbar-link a:hover {\n    text-decoration: underline;\n    color: #ffffff; /* Set the color when hovered */\n}\n\n.dbar-link a:active {\n    text-decoration: underline;\n    color: #ffffff; /* Same color as hover when active */\n}\n\n/* Links inside .regularFont */\n.regularFont a:link, .regularFont a:visited {\n    text-decoration: none;\n    color: #666666;  /* Color for links in regularFont */\n}\n\n.regularFont a:hover {\n    text-decoration: underline;\n    color: #ff6600;  /* Different color for hover effect */\n}\n\n.regularFont a:active {\n    text-decoration: underline;\n    color: #ff6600;  /* Same color as hover */\n}\n\n\n.dbar-formatName{\n    font-family: \"Josefin Sans\", sans-serif;\n    font-weight: 300;\n    letter-spacing: 1px;\n    color: #cccccc;\n    font-size: 18pt;\n    margin-right: 8px;\n    transform: translateY(1px);\n}\n\n.dbar-formatFont{\n    font-family: \"Rajdhani\", sans-serif;\n    font-weight: 600;\n    letter-spacing: 1px;\n    color: #cccccc;\n    font-size: 8pt;\n    margin-right: 10px;\n}\n\n.dbar-link {\n    font-family: \"Rajdhani\", sans-serif;\n    font-weight: 500;\n    letter-spacing: 1px;\n    color: #cccccc;\n    font-size: 13pt;\n    transform: translateY(-2px);\n    text-decoration: none;\n}\n\n.dbar-parent {\n    display: flex;\n  \n    width: 100%;\n    height: 28px;\n    display: flex;\n    align-items: center;\n    box-sizing: border-box;\n    position: relative;\n    margin-top: 4px;\n    /* border: 1px solid red; */\n    /* border-bottom: 1px solid grey; */\n}\n\n.dbar-diag {\n    position: absolute;\n    top: 22px;\n    left: 0;\n    transform: translateY(5px);\n    /* width: 40px; */\n    height: auto;\n    pointer-events: none;\n    display: none;\n}\n\n.dbar-left-section, .dbar-right-section {\n    display: flex;\n    align-items: center;\n    /* border: 1px solid red; */\n}\n\n.dbar-left-line {\n    width: 20px;\n    height: 1px;\n    background: #686868;\n    margin-right: 6px;\n    transform: translateY(-2px);\n}\n\n.dbar-left-text {\n    display: flex;\n    align-items: center;\n}\n\n.dbar-middle-line {\n    flex-grow: 1;\n    height: 1px;\n    background: #686868;\n    /* margin: 0 2px; */\n    transform: translateY(-2px);\n}\n\n.dbar-right-text {\n    display: flex;\n    align-items: center;\n    margin-left: 10px;\n}\n\n.dbar-right-text span {\n    margin-right: 5px;\n}\n\n.dbar-right-text .dbar-small {\n    font-size: 10pt;\n}\n\n.dbar-right-text{\n    font-size: 22pt;\n    margin-left: 10px;\n    cursor: pointer;\n    /* text-decoration: underline; */\n}\n\n/* ------------------------------perfect strangers------------------------------ */\n\n.ps-font1{\n    font-family: \"Rajdhani\", sans-serif;\n    font-size: 14px;\n    letter-spacing: 1px;\n    color: #cccccc;\n}\n\n.ps-font2{\n    font-family: \"Rajdhani\", sans-serif;\n    font-size: 18px;\n    letter-spacing: 1px;\n    color: #cccccc;\n}\n\n.ps-container {\n    display: flex;\n    width: 100%;\n    height: 420px;\n}\n\n.ps-column {\n    display: flex;\n    flex-direction: column;\n    padding: 10px;\n    width: 100%;\n}\n\n.ps-topDiv {\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.ps-topDiv img {\n    width: 60px;\n    height: 60px;\n    object-fit: cover;\n    margin-right: 10px;\n}\n\n.ps-textContainer {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.ps-topText {\n    \n}\n\n.ps-bottomText {\n    \n}\n\n.ps-bottomDiv {\n    margin-top: 10px;\n    text-align: justify;\n}\n\n#mainDiv .imageSplit.center {\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n}\n\n#mainDiv .imageSplit.center > img {\n    display: block;\n}\n\n/* ------------------------------mobile------------------------------ */\n\n@media (max-width: 715px) {\n    .textDiv {\n      padding-left: 8px;\n      padding-right: 8px;\n    }\n    .lineBorders {\n      border-top: 0px solid grey;\n      border-bottom: 0px solid grey;\n    }\n\n    #mainDiv .textDiv.lineBorders,\n    #mainDiv .linkDiv {\n      background: transparent;\n      border: none;\n    }\n\n    #mainDiv .textDiv.center:has(.footerFont),\n    #mainDiv .imageDiv.center:has(.footerFont) {\n      background: transparent;\n      border: none;\n    }\n    .image900 {\n      border-radius: 0px;\n    }\n    .thumb {\n      border-radius: 0px;\n      margin: 0px;\n      padding: 0px;\n      /* margin-bottom: 2px; */\n      /* border: 1px solid yellow; */\n    }\n    .imageContHalf,\n    .imageSplit {\n      flex-direction: column;\n      gap: 9px;\n    }\n\n    .imageSplit.center:has(.characterBlock) {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n      gap: 9px;\n      width: 100%;\n      justify-items: center;\n      align-items: start;\n    }\n\n    .imageSplit.center:has(.characterBlock) .characterBlock {\n      width: 100%;\n    }\n\n    .imageSplit.center:has(.characterBlock) .contCharacter {\n      height: auto;\n      width: 100%;\n      max-width: 100%;\n      object-fit: cover;\n    }\n\n    #mainDiv #container900 > .imageCont,\n    #mainDiv #container900 > .imageContHalf,\n    #mainDiv #container900 > .imageSplit,\n    #mainDiv #container900 > .gameSystemsSixPack {\n      gap: 9px;\n    }\n\n    .imageHalf {\n      width: 100%;\n      margin-bottom: 0;\n    }\n    .gameSystemsSixPack {\n      flex-direction: row;\n      flex-wrap: wrap;\n      gap: 9px;\n      justify-content: center;\n    }\n    .gameSystemsSixPackImage {\n      flex: 0 0 calc((100% - 9px) / 2);\n      width: calc((100% - 9px) / 2);\n      max-width: none;\n      margin-bottom: 0;\n    }\n    .gameSystemsSixPackImage:nth-child(5) {\n      display: none;\n    }\n    #mainDiv #container900 > .dbar-parent {\n      margin-bottom: 0;\n    }\n    .imagePart {\n      display: none;\n    }\n    .greyBorder {\n      border: 0px solid grey;\n    }\n    .dbar-parent {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      text-align: center;\n      margin-bottom: 0;\n      width: 100%;\n      box-sizing: border-box;\n      /* border: 1px solid green; */\n    }\n    .dbar-left-section,\n    .dbar-right-section {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      box-sizing: border-box;\n      /* border: 1px solid blue; */\n    }\n    .dbar-left-text,\n    .dbar-right-text {\n      display: flex;\n      /* flex-direction: column; */\n      align-items: center;\n      margin: 0;\n      padding: 0;\n    }\n    .dbar-left-text span,\n    .dbar-right-text span {\n      display: block;\n      margin: 0 0;\n      text-align: center;\n    }\n    .dbar-left-line {\n      display: none;\n      order: 0;\n      width: 20px;\n      height: 1px;\n      background: #686868;\n    }\n    .dbar-formatName {\n      order: 1;\n      transform: none !important;\n      text-align: center;\n      margin: 0;\n      padding: 0;\n      /* border: 1px solid red; */\n    }\n    .dbar-middle-line {\n      display: none;\n      order: 2;\n      width: 20px;\n      height: 1px;\n      background: #686868;\n    }\n    .dbar-link {\n      transform: none !important;\n      text-align: center;\n      margin: 0;\n      padding: 2px;\n      font-size: 15px;\n      /* text-decoration: underline; */\n    }\n    .dbar-diag {\n      display: none;\n    }\n    .dbar-launchFont {\n      display: none !important;\n    }\n    .dbar-projectFont {\n      display: none !important;\n    }\n    .dbar-formatFont {\n      display: none !important;\n    }\n    .pressLink {\n      margin-left: 0;\n      margin-right: 0;\n      padding: 0;\n    }\n    .linkDiv {\n      text-align: center;\n      padding: 0;\n      margin: 0 auto;\n      transform: translateY(2px);\n    }\n\n    .linkDiv.divPar {\n      width: 100%;\n      max-width: 100%;\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: center;\n      align-items: center;\n      gap: 4px 8px;\n    }\n    .nothingHide{\n        display:none !important;\n    }\n    .nothingHide2{\n        height: 4px;\n    }\n    .greyLine2 {\n        display: block;\n    }\n    .textDivDown{\n        transform: translateY(5px);\n    }\n    .textDivUp{\n        transform: translateY(-3px);\n    }\n    .videoContainer{\n        border: none;\n    }\n    .ps-container{\n        display: none;\n    }\n    .divPar{\n        width: 100%;\n        max-width: 100%;\n    }\n    .mobileLogo{\n        width: 70%;\n    }\n  }\n\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
